export default __webpack_public_path__ + "static/media/Gold-Trophy.7be342d3.png";